// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

// 3rd Party
// tslint:disable-next-line: ban-types
declare var ga: Function; // <-- Here we declare GA variable

// --- HS Code
import { environment } from '../../../../environments/environment';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class AnalyticsServiceService {

  constructor(router: Router) {
    if (!environment.production) { return; } // <-- If you want to enable GA only in production

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.url);
        ga('send', 'pageview');
      }
    });
  }
}
